import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMinusIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M6 13a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgMinusIcon;